import { render, staticRenderFns } from "./editStorebrand.vue?vue&type=template&id=6f563dc6&scoped=true"
import script from "./editStorebrand.vue?vue&type=script&lang=js"
export * from "./editStorebrand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f563dc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f563dc6')) {
      api.createRecord('6f563dc6', component.options)
    } else {
      api.reload('6f563dc6', component.options)
    }
    module.hot.accept("./editStorebrand.vue?vue&type=template&id=6f563dc6&scoped=true", function () {
      api.rerender('6f563dc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rsManagement/goodsBrand/editStorebrand.vue"
export default component.exports